import * as actions from '../actions'
import { REDUCER_INDEX } from '../constants'

export const getInitialState = () => ({
  notifications: [],
})

const reducer = (state = getInitialState(), action = {}) => {
  switch (action.type) {
    case actions.NT_ADD: {
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      }
    }
    case actions.NT_CLEANUP: {
      return {
        ...state,
        notifications: [],
      }
    }
    case actions.NT_REMOVE: {
      return {
        ...state,
        notifications: state.notifications.filter((n) => n.id !== action.payload),
      }
    }
    default:
  }
  return state
}

export const registerReducer = (state) => ({
  ...state,
  [REDUCER_INDEX]: reducer,
})

export const getState = (state) => state[REDUCER_INDEX]

export default reducer
